import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  info: {
    display: "flex",
    justifyContent: "space-between",
  },
  infoWrap: {
    display: "flex",
    alignItems: "center",
    width: "90%",
  },
  checkbox:{
    '& .MuiSvgIcon-root': {fontSize: 24},
  },
}));

export default useStyles;
